import Rest from '../Rest'

export default class EmailTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/email_types'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
